/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyRefundBill } from 'app/shared/model/pharmacy-refund-bill.model';

export interface IPharmacyRefundPayment {
  id?: string;
  paymentMethod?: string | null;
  transactionDetails?: string | null;
  paidAmount?: number | null;
  active?: boolean | null;
  cursor?: number;
  timestampentry?: number | null;
  microSec?: number | null;
  lastupdated?: number | null;
  forCredit?: boolean | null;
  voided?: boolean | null;
  voidedReason?: string | null;
  voidedDate?: number | null;
  refundBill?: IPharmacyRefundBill | null;
}

export const defaultValue: Readonly<IPharmacyRefundPayment> = {
  active: false,
  forCredit: false,
  voided: false,
};
